import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { getUserRoles, hasRouteAccess } from 'utils/authority';

const AuthorityRoute = ({ roles, children }) => {
  const storedRoles = useSelector((state) => state.auth.roles);
  const userRoles = storedRoles?.length ? storedRoles : getUserRoles();

  if (!hasRouteAccess(userRoles, roles)) {
    return <Navigate to={AUTHENTICATED_ENTRY} replace />;
  }

  return children;
};

export default AuthorityRoute;
